<template>
  <NewLibraryButton
    color-type="none-stroke"
    :disabled="disabled"
    @click="handleClickEvent"
  >
    + Add New
  </NewLibraryButton>
</template>

<script>
import NewLibraryButton from "@/NewLibrary/Button.vue";

export default {
  components: {
    NewLibraryButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],

  methods: {
    handleClickEvent() {
      this.$emit("click");
    }
  }
}
</script>
